import { Collapse } from '@mui/material'
import cn from 'classnames'
import React, { ReactNode, useState } from 'react'
import SvgChevronUp from 'src/components/Svgs/SvgChevronUp'

import style from './Accordion.style'

export interface AccordionProps {
  title: string
  subtitle?: ReactNode
  children: ReactNode
  className?: string
  defaultExpanded?: boolean
  expanded?: boolean
  onExpandedChange?: (expanded: boolean) => void
}

export default function Accordion({
  title,
  subtitle,
  children,
  className = '',
  defaultExpanded = false,
  expanded: externalExpanded,
  onExpandedChange,
}: AccordionProps): React.ReactElement {
  const [internalExpanded, setInternalExpanded] = useState(defaultExpanded)

  // Use controlled value if provided, otherwise use internal state
  const expanded =
    externalExpanded !== undefined ? externalExpanded : internalExpanded
  const isControlled = expanded !== undefined

  const toggleExpanded = () => {
    const newExpanded = !expanded

    if (isControlled) {
      onExpandedChange?.(newExpanded)
    } else {
      setInternalExpanded(newExpanded)
    }
  }

  return (
    <div className={cn('Accordion', className)} css={style}>
      <div
        className="accordion-header"
        onClick={toggleExpanded}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault()
            toggleExpanded()
          }
        }}
      >
        <div>
          <span className="accordion-title">{title}</span>
          {subtitle && <div className="accordion-subtitle">{subtitle}</div>}
        </div>
        <div className={cn('chevron-icon', { expanded })}>
          <SvgChevronUp width={24} height={24} viewBox={'0 0 24 24'} />
        </div>
      </div>
      <Collapse in={expanded}>
        <div className={'accordion-content'}>{children}</div>
      </Collapse>
    </div>
  )
}
